import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function setAuthToken(token: string): void {
  apiClient.defaults.headers['Authorization'] = `Bearer ${token}`;
  localStorage.setItem('auth_token', token);
}

export function clearAuthToken(): void {
  delete apiClient.defaults.headers['Authorization'];
  localStorage.removeItem('auth_token');
}

export function getStoredToken(): string | null {
  return localStorage.getItem('auth_token');
}

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthToken();
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);
